export default "__VITE_ASSET__DcXxOYrU__"